export const createNewVariableOption = (variableId) => ({
  name: '',
  value: '',
  variable_id: variableId,
  uid: new Date().getTime(),
});
